module.exports = __webpack_public_path__ + "static/media/home.57cc5fdb.svg";